import { useTeamSettingsFlow } from "../../../application/v2";
import { TeamSettingsPageV2 } from "../../../ui/pages/v2/TeamSettingsPage";

export function TeamSettingsV2Route() {
  const flow = useTeamSettingsFlow();

  return <TeamSettingsPageV2 {...flow} />;
}
